import React from 'react';

import { themeStyle, useNewThemeActive } from '@repo/ui/theming';

import DefaultSpinner from '../../utilities/Spinner/Spinner';

import { LoadingWrapper } from './styles';
import { LoadingPlaceholderProps } from './types';

const theme = {
  color: themeStyle.brandMain,
  trackColor: themeStyle.varInkLight,
  borderWidth: '4px',
};

const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = ({
  backgroundStyle,
}) => {
  const isNewThemeActive = useNewThemeActive();

  return (
    <LoadingWrapper backgroundStyle={backgroundStyle}>
      <DefaultSpinner
        size="32px"
        theme={
          isNewThemeActive ? { ...theme, color: themeStyle.varBlueMain } : theme
        }
      />
    </LoadingWrapper>
  );
};

export default LoadingPlaceholder;
